export default __webpack_public_path__ + "static/media/SG-Green-0006.a51201de.png";